import { render, staticRenderFns } from "./wmenuIndex.vue?vue&type=template&id=d3aa639a&scoped=true"
import script from "./wmenuIndex.vue?vue&type=script&lang=js"
export * from "./wmenuIndex.vue?vue&type=script&lang=js"
import style0 from "./wmenuIndex.vue?vue&type=style&index=0&id=d3aa639a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3aa639a",
  null
  
)

export default component.exports